import Vue from 'vue'

const getDefaultState = () => {
    return {
        templateEmail: {
            id: 0,
            template: null,
            subject: "",
            description: ""
        }
    }
};

const state = getDefaultState();

const actions = {
    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async ListTemplateType() {
        try {
            const result = await Vue.prototype.$vanKirkApi.get(`template-email/list-template-types`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                return result.data.result;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return [];
        }
    },

    async List() {
        // generic list of existing template emails (optional)
        try {
            const result = await Vue.prototype.$vanKirkApi.get(`template-email/list`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                return result.data.result;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error listing template emails: [${ex}]`
            };
        }
    },

    async GetById(_, id) {
        try {
            const result = await Vue.prototype.$vanKirkApi.get(`template-email/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error getting template email`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error getting template email: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, templateEmailRequest) {
        try {
            const result = await Vue.prototype.$vanKirkApi.post(`template-email/create-update`, templateEmailRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                let msg = "Record updated successfully";
                if (templateEmailRequest.id === 0) {
                    msg = "Record created successfully";
                }
                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error creating/updating template email"
                };
            }
        }
        catch(error) {
            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error creating/updating template email: [${error.response.data}]`
                };
            }
            else {
                return {
                    success: false,
                    message: `Error creating/updating template email: [${error}]`
                };
            }
        }
    },

    async SendEmailToCustomer(_, emailRequest) {
        try {
            const result = await Vue.prototype.$vanKirkApi.post(`template-email/send-email`, emailRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200 || result.data.success) {
                return {
                    success: true,
                    message: 'Email sent successfully'
                };
            }
            else {
                return {
                    success: false,
                    message: result.data.message || 'Error sending email'
                };
            }
        }
        catch(error) {
            return {
                success: false,
                message: `Error sending email: [${error.message || error}]`
            };
        }
    }
};

const mutations = {
    saveState: (state, newValue) => {
        Object.assign(state.templateEmail, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {
    searchState: (state) => {
        return state.templateEmail;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}